import React from 'react'
import Helmet from 'react-helmet'

import data from '../../data/digital-realities'
import SlideshowFooter from '../../components/SlideshowFooter'

let prev = '/digital-realities/ar_colony-square';
let next = '/digital-realities/vr_250-williams';

let sliderImages = data[1].slideshow.map( (img, idx) => {
    return(
        <div key={`image-${idx}`} >
            <img src={img} alt=""/>
        </div>
    )
});

const DigitalRealities = (props) => (
    <div id="digital-reality-landing">
        <Helmet>
            <title>IMBIBE - Digital Realities: What is Virtual Reality?</title>
            <meta name="description" content="What is Virtual Reality?" />
        </Helmet>

        <img src="http://dev.imbibe.info/images/ar_what-is-ar/hero.jpg" />

        <div id="main">
            <section id="one">
                <div className="inner">
                    <h1>What is AR?</h1>
                    <p>Officially, Augmented Reality is “a technology that superimposes a computer-generated image on a user's view of the real world, thus providing a composite view.”</p>
                    <p>Unlike Virtual Reality, where you are placed in an entirely new environment, augmented reality allows a user to still see and interact with the world around them, but with the addition of supplemental content (images and data).</p>
                    {/*<ul className="actions">*/}
                    {/*<li><a href="#" className="button special small">New to VR? Learn more</a></li>*/}
                    {/*</ul>*/}
                </div>
                {sliderImages}
            </section>
        </div>

        <SlideshowFooter vr prev={prev} next={next} />

    </div>
)

export default DigitalRealities


// WEBPACK FOOTER //
// ./src/pages/digital-realities/what-is-ar.js